import usePagination from '@/hooks/usePagination';
import { SortType } from '@/types/schema';

import { useScorecardsQuery } from '../graphql/queries/generated/scorecards';

export default function useScorecards({
  searchString,
  ids,
  sort,
}: {
  searchString?: string;
  ids?: string[];
  sort?: SortType;
}) {
  const { data, error, isFetching, fetchMore } = usePagination(
    useScorecardsQuery,
    {
      filters: {
        title: searchString,
        ids,
      },
      sort,
    },
    { edgeKey: 'scorecards' },
  );

  return {
    scorecards: data,
    error,
    fetchMore,
    initialFetching: isFetching,
  };
}
